/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_Tile_Activate_TitleInputs */

const en_home_hero_tile_activate_title = /** @type {(inputs: Home_Hero_Tile_Activate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activate Your Access`)
};

const fr_home_hero_tile_activate_title = /** @type {(inputs: Home_Hero_Tile_Activate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activer votre accès`)
};

/**
* | output |
* | --- |
* | "Activate Your Access" |
*
* @param {Home_Hero_Tile_Activate_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_hero_tile_activate_title = /** @type {((inputs?: Home_Hero_Tile_Activate_TitleInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_Tile_Activate_TitleInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_hero_tile_activate_title(inputs)
	return fr_home_hero_tile_activate_title(inputs)
});